import React, { useState } from "react";
import FormBuilder from "../form_components/FormBuilder";
import Input from "../form_components/Input";
import { useAppSelector } from "../../hooks";
import SearchSelect from "components/form_components/SearchSelect";

export default function ModifyProjectPopup() {
    const current_project = useAppSelector(state => state.Projects.current_project);

    type Port = { short: string; name: string };

    const [departurePort, setDeparturePort] = useState<Port | null>(null);
    const [arrivalPort, setArrivalPort] = useState<Port | null>(null);
    if (!current_project) return null;
    return (
        <FormBuilder 
            title="Modify Project" 
            post="/projects/modifyProject" 
            initialValues={
                { 
                    name: current_project.name, 
                    chief_scientist: current_project.chief_scientist,
                    departure_port: current_project?.departure_port || "",
                    arrival_port: current_project?.arrival_port || "",
                    start_date: current_project?.start_date.toLocaleString(),
                    end_date: current_project?.end_date.toLocaleString()

                    
                }
            }
        >
            <Input
                width="full"
                label="Project Name"
                type="text"
                placeholder="Enter project name"
                extraClasses="border block rounded px-2"
                required={true}
                name="name"
            />

            <Input
                width="full"
                label="Chief Scientist"
                type="text"
                placeholder=""
                extraClasses="border block rounded px-2"
                name="chief_scientist"
            />

            <SearchSelect<Port>
                width="full"
                label="Departure Harbour"
                name="departure_port"       
                dataUrl="/data/ports.json"
                getOptionLabel={(o) => o.name} 
                getOptionValue={(o) => o.short}  
                extraClasses="border block rounded px-2"
            />
            
            <SearchSelect<Port>
                width="full"
                label="Arrival Harbour"
                name="arrival_port"       
                dataUrl="/data/ports.json"
                getOptionLabel={(o) => o.name} 
                getOptionValue={(o) => o.short} 
                extraClasses="border block rounded px-2"
            />

            <Input
                width="full"
                label="Project Start"
                type="date"
                placeholder=""
                extraClasses="border block rounded px-2"
                name="start_date"
            />

            <Input
                width="full"
                label="Project end"
                type="date"
                placeholder=""
                extraClasses="border block rounded px-2"
                name="end_date"
            />

        </FormBuilder>
    );
}
